export enum ARTICLE_CATEGORY {
    CORPORATE = 'corporate_article',
    MAGAZINE = 'magazine_article',
    MENU_ARTICLE = 'menu_article',
    FAQ = 'faq_entity'
}